import PropTypes from "prop-types"
import { safeDivide } from "helpers/math"

function ChartDefs({ pathId, axisId, bandsId, limitBandsId, offset, chartWidth = 0 }) {
  const gradientsOffset = `${safeDivide(offset, chartWidth) * 100}%`

  return <defs>
    <linearGradient id={pathId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-path-start" />
      <stop offset={gradientsOffset} className="selected-path-end" />
    </linearGradient>
    <linearGradient id={axisId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-axis-start" />
      <stop offset={gradientsOffset} className="selected-axis-end" />
    </linearGradient>
    <linearGradient id={bandsId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-bands-start" />
      <stop offset={gradientsOffset} className="selected-bands-end" />
    </linearGradient>
    <linearGradient id={limitBandsId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-limit-bands-start" />
      <stop offset={gradientsOffset} className="selected-limit-bands-end" />
    </linearGradient>
  </defs>
}

ChartDefs.propTypes = {
  pathId: PropTypes.string.isRequired,
  axisId: PropTypes.string.isRequired,
  bandsId: PropTypes.string.isRequired,
  limitBandsId: PropTypes.string.isRequired,
  offset: PropTypes.number,
  chartWidth: PropTypes.number,
}

export default ChartDefs
